export const IntegrationTypes = {
  Xero: "Xero",
};
